import FetchService from "./Shared/FetchService";
export default class ExternalLinksService {
    static getExternalLinksForPerson(personAffiliationId) {
        return FetchService.get("/aviso/advisor/getExternalLinks", {
            affiliationId: personAffiliationId,
        });
    }
}
